const marketing = [
	{
		path: '/network/marketing/campaigns-banners/list',
		name: 'network-marketing-campaigns-banners-list',
		component: () => import('@/views/network/marketing/campaigns-banners/list.vue'),
		meta: {
			layout: 'content',
			module: 'admin_master',
		},
	},
]

export default marketing
